import {
  IconDefinition,
  faCircleQuestion,
} from '@fortawesome/pro-regular-svg-icons';
import * as Icons from '@fortawesome/pro-regular-svg-icons';
import { FontSize, Icon as VIcon } from '@nettbureau/vibrant-ui';
import { Suspense } from 'react';

interface IconProps {
  icon: IconDefinition;
  size?: FontSize;
}

export interface DynamicIconProps {
  iconName: keyof typeof Icons;
  size?: FontSize;
}

const Icon = ({ icon, size }: IconProps) => (
  <VIcon icon={icon} size={size ?? 'md'} />
);
Icon.displayName = 'DynamicIcon';

export const DynamicIcon = ({ iconName, size }: DynamicIconProps) => {
  const icon = (Icons[iconName] as IconDefinition) || faCircleQuestion;

  return (
    <Suspense>
      <Icon data-featured-card-product-detail-icon icon={icon} size={size} />
    </Suspense>
  );
};
